import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'alm-react-components';
import React, {ReactElement, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DialogModalBody from './DialogModalBody';
import closeImg from "./../../assets/images/svgicons/close-sm.svg";

type DialogModalProps = {
  title?: string;
  footer?: any;
  header?: any;
  body?: ReactElement;
  open: boolean;
  onClose?: any;
  onButtonClick?: any;
};

const DialogModal: React.FC<DialogModalProps> = ({
  open = false,
  title,
  body,
  onClose,
  onButtonClick,
}) => {
  const [show] = useState<boolean>(open);
  const {t} = useTranslation();
  const closeModal = () => {
    onClose();
  };
  const dialogHeader = () => {
    return (
      <AlertDialogHeader className="justify-between flex-row absolute right-0 top-3 z-50">
        <AlertDialogCancel
          onClick={closeModal}
          className="sm w-max border-0 bg-transparent hover:bg-transparent"
        >
          <img src={closeImg} alt={" "} className="w-[21px] h-[20px]" />
        </AlertDialogCancel>
      </AlertDialogHeader>
    );
  };
  return (
    <AlertDialog open={show}>
      <AlertDialogContent className="bg-[#16171C] py-6 px-3 max-md:px-6 md:px-12 w-full text-center border border-primary overflow-hidden max-w-[430px] block">
        {dialogHeader()}
        <AlertDialogTitle className="font-barlowRegular font-normal uppercase text-lg z-[1] relative">
          {t('Program.text')}
        </AlertDialogTitle>
        <AlertDialogDescription className="flex h-1/2 flex-col">
          <DialogModalBody body={body} title={title} />
        </AlertDialogDescription>
        <AlertDialogFooter className="lg:justify-center z-[1] relative">
          <AlertDialogAction
            onClick={() => onButtonClick()}
            className="w-full font-opensansSemiBold text-base uppercase-btn h-10 "
          >
            {' '}
            {t('Common.viewRecommendedContent')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
export default DialogModal;
